/* akk-header.js: the mega menu and the phone drawer. Panels open on a real
   button (keyboard, touch) and on hover with a little intent (mouse). */

(() => {
  'use strict';
  if (window.__akkHeaderLoaded) return;
  window.__akkHeaderLoaded = true;

  const hoverable = window.matchMedia('(hover: hover) and (pointer: fine)');

  /* The header is bound per element: the theme editor re-renders the section on
     every setting change (shopify:section:load), so the new element is bound
     again and the old listeners die with the old nodes. */
  const init = (header) => {
  if (!header || header.dataset.akkBound) return;
  header.dataset.akkBound = '1';
  const items = [...header.querySelectorAll('[data-akk-nav-item]')];
  let openItem = null;
  let pinned = null; // the item whose Megamenu block is selected in the editor
  let timer = 0;

  const panelOf = (item) => item.querySelector('.akk-hdr__panel');
  const toggleOf = (item) => item.querySelector('[data-akk-nav-toggle]');

  const close = (item) => {
    if (!item) return;
    panelOf(item).hidden = true;
    toggleOf(item).setAttribute('aria-expanded', 'false');
    item.classList.remove('is-open');
    if (openItem === item) openItem = null;
  };
  const open = (item) => {
    if (openItem && openItem !== item) close(openItem);
    panelOf(item).hidden = false;
    toggleOf(item).setAttribute('aria-expanded', 'true');
    item.classList.add('is-open');
    openItem = item;
  };
  const closeAll = () => { if (openItem) close(openItem); };

  for (const item of items) {
    const toggle = toggleOf(item);
    toggle.addEventListener('click', () => (openItem === item ? close(item) : open(item)));
    item.addEventListener('mouseenter', () => {
      if (!hoverable.matches) return;
      clearTimeout(timer);
      timer = setTimeout(() => open(item), 120);
    });
    item.addEventListener('mouseleave', () => {
      if (!hoverable.matches || pinned === item) return;
      clearTimeout(timer);
      timer = setTimeout(() => { if (openItem === item && pinned !== item) close(item); }, 220);
    });
    item.addEventListener('focusout', (event) => {
      if (!item.contains(event.relatedTarget) && pinned !== item) close(item);
    });
  }

  header.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape' || !openItem || pinned === openItem) return;
    const toggle = toggleOf(openItem);
    close(openItem);
    toggle.focus();
  });
  document.addEventListener('pointerdown', (event) => {
    if (openItem && openItem !== pinned && !openItem.contains(event.target)) closeAll();
  });

  /* Theme editor: a selected Megamenu block opens its panel in the preview and
     keeps it open until the block is deselected. The block's element is the
     panel itself (shopify_attributes), or the note under the nav for a block
     whose word matches nothing. */
  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:block:select', (event) => {
      const item = event.target.closest && event.target.closest('[data-akk-nav-item]');
      if (!item || !header.contains(item)) return;
      pinned = item;
      open(item);
    });
    document.addEventListener('shopify:block:deselect', (event) => {
      const item = event.target.closest && event.target.closest('[data-akk-nav-item]');
      if (!item || !header.contains(item)) return;
      if (pinned === item) pinned = null;
      close(item);
    });
  }

  /* the drawer */
  const drawer = header.querySelector('dialog.akk-drawer');
  const opener = header.querySelector('[data-akk-drawer-open]');
  if (drawer && opener && typeof drawer.showModal === 'function') {
    opener.addEventListener('click', () => {
      drawer.showModal();
      opener.setAttribute('aria-expanded', 'true');
      document.documentElement.classList.add('akk-drawer-open');
    });
    drawer.addEventListener('close', () => {
      opener.setAttribute('aria-expanded', 'false');
      document.documentElement.classList.remove('akk-drawer-open');
    });
    drawer.addEventListener('click', (event) => {
      if (event.target.closest('[data-akk-drawer-close]')) drawer.close();
      else if (event.target === drawer) drawer.close();
    });
  }
  };

  init(document.querySelector('[data-akk-header]'));
  document.addEventListener('shopify:section:load', (event) => init(event.target.querySelector('[data-akk-header]')));
})();
